import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatIconRegistry } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { DomSanitizer } from '@angular/platform-browser';
import { IColumnData, IInputType } from 'app/models/dialog-interface';
import { ReportCalculation } from 'app/models/ReportCalculation';
import { IColumns, ITableDetails } from 'app/models/table-interfaces';
import { RouteBreadcrumbService } from 'app/services/route-breadcrumb.service';
import { ReportCalculationService } from 'app/services/reporting-calculation.service';
import { TableService } from 'app/services/target-table.service';
import { EditComponent } from 'app/shared/components/edit/edit.component';
import { Subject } from 'rxjs';
import { SnackBarHandler } from 'utilities/snackbar';
import { ImportCalculationsDialogComponent } from './import-calculations-dialog/import-calculations-dialog.component';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'dp-filebased-source-calculation-group',
    templateUrl: './calculation-group.component.html',
    providers: [ReportCalculationService, TableService, SnackBarHandler],
    'styleUrls': ['./calculation-group.component.scss']
})

export class FileBasedSourceCalculationGroup implements OnInit {

    @ViewChild(DataTableDirective)
    powerUser:boolean = true;
    id: string;
    id2: string;
    serviceData:any;
    ref: boolean;
    enableImport:boolean = false;
    tableDetails: ITableDetails;
    private destroy = new Subject<void>();
    columns: IColumns[] = [
      {
        columnDef: "ReportCalculationGroupId",
        header: "Group Id",
        sortable: true,
        cell: (element: any) => `${element.ReportCalculationGroupId}`
      },
      {
        columnDef: "ReportCalculationTableName",
        header: "Calculation Table Name",
        sortable: true,
        cell: (element: any) => `${element.ReportCalculationTableName}`
      }
    ];


    constructor(
      private route: ActivatedRoute, 
      private reportCalculationService: ReportCalculationService,
      private snackBarHandler: SnackBarHandler,
      private router: Router,
      private authService: AuthService,
      private dialog: MatDialog,
      private routeBreadcrumbService: RouteBreadcrumbService,
      private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        this.id = this.route.snapshot.paramMap.get('id');
        this.id2 = this.route.snapshot.paramMap.get('id2');

        this.tableDetails = { routing: { routingPath: [`/filesource/reports/${this.id}/calculations/${this.id2}/group/`] }, edit: false };
        this.serviceData = this.authService.getFakeSubscribe([]);
        this.authService.authorizeSection().subscribe(permissions =>{
          if(permissions.view){
            var details = { routing: { routingPath: [`/filesource/reports/${this.id}/calculations/${this.id2}/group/`] }, edit: permissions.update }
            if(permissions.add){
              this.enableImport = true;
            }
            if(permissions.delete){
              details['delete'] = "ReportCalculationTableName";
              details['deleteId'] = "ReportCalculationGroupId";
            }

            this.tableDetails = details;
            this.serviceData = this.reportCalculationService.getReportCalculationGroupsByReportId(this.id2);
            this.ref = true;
          }
          else {
            this.router.navigate(['/']);
          }
        });
        this.ref = false;
        this.matIconRegistry.addSvgIcon('importCalculations', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/pictures/Import_Tables.svg'));
      }

    ngOnInit() {
        this.routeBreadcrumbService.updateBreadcrumbTitlesState(["Filebased Calculations", this.id2], ["filesource/", "filesource/reports/" + this.id]);
    }

    ngOnDestroy(){
      this.destroy.next;
      this.destroy.complete;
      this.routeBreadcrumbService.updateBreadcrumbTitlesState([], []);
    }

    private openImportCalculationsDialog() {
      this.dialog.open(ImportCalculationsDialogComponent, {
          panelClass: 'custom-dialog-container',
          data: { SourceId: this.id, ReportId: this.id2 },
      })
          .afterClosed().subscribe(result => {
              if (result) {
                this.snackBarHandler.open('Starting Report Import', 'success');
                for(var i = 0; i < result.length; i++){
                  result[i].Id = 0;
                }
                this.reportCalculationService.putCalculationsDataFromSource(result).subscribe(savedReports => {
                    this.snackBarHandler.open(`Success: Calculations Imported'`, 'success');
                    this.ref = true;
                }, err => this.snackBarHandler.open(`Failure: Calculations not Imported`, 'failure'));
              }
          });
    }  

    private editModal(calculation: ReportCalculation){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = "custom-dialog-container";

      let columnData: IColumnData[] = [
        {
          id: "Id",
          label: -1,
          value: -1,
          validators: []
        },
        {
          id: "ReportCalculationTableName",
          label: "Calculation Table Name",
          value: calculation.ReportCalculationTableName,
          validators: ["required"]
        }
      ];
      let data = {
        description: "Edit " + calculation.ReportCalculationTableName,
        numCols: 2,
        columnData: columnData
      };
      dialogConfig.data = data;

      const dialogRef = this.dialog.open(EditComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
            result.ReportCalculationGroupId = calculation.ReportCalculationGroupId;
            this.reportCalculationService.saveReportCalculationGroup(result).subscribe(savedGroup => {
              if (savedGroup) {
                this.snackBarHandler.open(`Success: Edited '${result.ReportCalculationTableName}'`, 'success');
                this.ref = true;
              }
            }, err => this.snackBarHandler.open(`Failure: Group not edited`, 'failure'));
        }
      });
    }

    private deleteRows(rows: ReportCalculation[]){
      for (let row of rows) {
        this.reportCalculationService.deleteReportCalculationGroup(row['id']).subscribe(result => {
          this.snackBarHandler.open(`Success: Selected item(s) have been deleted`, 'success');
          this.ref = true;
        }, err => this.snackBarHandler.open(`Failure: Selected item(s) not deleted`, 'failure'));
      }
    }

    resetRefresh(value: boolean) {
      this.ref = value;
    }
}